exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.weui-icon-success, .weui-icon-circle{\n    font-size: 0.18rem !important;\n}\n.vux-check-icon > .weui-icon-success:before, .vux-check-icon > .weui-icon-success-circle:before {\n    color: #7E60FF !important;\n}\n", ""]);

// exports
